module.exports = __webpack_public_path__ + "static/media/soash_long_burns.35e9ecfd.gif";